/* @flow */
import * as React from 'react';
import { graphql } from 'react-apollo';
import pluralize from 'pluralize';

import ConfirmDialog from 'components/ConfirmDialog';
import ToastActions from 'actions/ToastActions';

import REMOVE_MEMBERS_FROM_GROUP_MUTATION from 'groups/components/mutations/removeMembersFromGroup.gql';

import type {
  RemoveUsersFromGroupInput,
  removeMembersFromGroup_removeUsersFromGroup,
} from 'groups/components/mutations/__generated__/removeMembersFromGroup';

type Props = {
  groupUuid: string,
  userIds: number[],
  onRequestHide: () => void,
  onRemoval: () => void,
  removeMembersFromGroup: ({ variables: { input: RemoveUsersFromGroupInput } }) => Promise<
    removeMembersFromGroup_removeUsersFromGroup
  >,
};

class RemoveMembersFromGroupDialog extends React.Component<Props> {
  removeMembers = () => {
    const { groupUuid, onRequestHide, onRemoval, removeMembersFromGroup, userIds } = this.props;
    const numOfUsers = userIds.length;

    removeMembersFromGroup({ variables: { input: { groupUuid, ids: userIds } } })
      .then(() => {
        ToastActions.showSuccessToast(
          `${numOfUsers} ${pluralize('user', numOfUsers)} ${pluralize(
            'was',
            numOfUsers
          )} removed from class.`
        );
        onRemoval();
      })
      .catch(() => {
        ToastActions.showErrorToast(
          `Unable to remove ${pluralize('user', numOfUsers)} from class. Please try again later.`
        );
      });

    onRequestHide();
  };

  render() {
    const { onRequestHide, userIds } = this.props;

    return (
      <ConfirmDialog
        eventScreenName="RemoveMembersFromGroupDialog"
        actionButtonText="Remove"
        cancelButtonText="Cancel"
        size="xsmall"
        onCancel={onRequestHide}
        onConfirm={this.removeMembers}
        title={`Remove ${pluralize('participant', userIds.length)}?`}
        subtext={
          `${pluralize('This', userIds.length)} ${pluralize('person', userIds.length)} ` +
          'won’t receive announcements or be available ' +
          'for direct messaging. You can always change this later.'
        }
      />
    );
  }
}

const withRemoveMembersMutation = graphql(REMOVE_MEMBERS_FROM_GROUP_MUTATION, {
  name: 'removeMembersFromGroup',
});
export { RemoveMembersFromGroupDialog };
export default withRemoveMembersMutation(RemoveMembersFromGroupDialog);
